import { useState } from "react";
import { SignatureModal } from "../components/signature";

export default function TestSignature() {
    const [open, setOpen] = useState(false);
    const [signature, setSignature] = useState("");

    return (
        <>
            <button onClick={() => setOpen(true)}>
                Sign
            </button>

            <SignatureModal
                open={open}
                onClose={() => setOpen(false)}
                onSave={setSignature}
            />

            {signature && (
                <div className="mt-6">
                    <h3 className="font-semibold mb-2">Saved Signature</h3>

                    <img
                        src={signature}
                        alt="Signature"
                        className="border rounded bg-white"
                    />
                </div>
            )}
        </>
    );
}